import { FC, ReactNode } from 'react'

interface InterlinkProps {
  url: string | undefined
  children: ReactNode
}

const Interlink: FC<InterlinkProps> = ({ url, children }) => {
  if (url) {
    return <a href={url}>{children}</a>
  }

  return <>{children}</>
}

export default Interlink
